module.exports = __webpack_public_path__ + "img/dbjiej_800.59cfe635.jpg";